import { ChangeDetectionStrategy, Component } from '@angular/core';
import { MapComponent } from '../map/map.component';
import { ReCaptchaV3Service } from 'ng-recaptcha';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'app-public-map',
  standalone: true,
  imports: [MapComponent, CommonModule],
  template: `<app-map [executeRecaptcha]="executeRecaptcha"></app-map>`,
  styleUrls: ['./public-map.component.css'],
})
export class PublicMapComponent {
    
    constructor(
        private recaptchaV3Service: ReCaptchaV3Service,
    ) {
    }

    executeRecaptcha = (action: string) => {
        return this.recaptchaV3Service?.execute(action);
    }

}
